import React from 'react';
import { observer } from 'mobx-react';
import { CardTypeStore } from '@seedlang/stores';
import ButtonPrimary from 'components/button/button_primary';

@observer
class CardTypeCreate extends React.Component {

  onClick() {
    CardTypeStore.create(
      {
        data: {
          name: this.refs.name.value,
        },
      },
    );
    this.refs.name.value = '';
  }

  render() {
    return (
      <div className='card-type-create'>
        <input
          placeholder='Add a name'
          ref='name'
        />
        <div>
          <ButtonPrimary onClick={this.onClick.bind(this)}>
            Create
          </ButtonPrimary>
        </div>
      </div>
    );
  }
}

export default CardTypeCreate;
